/**
 * useBuddyGroupPermissions — convenience hook for buddy-group action checks.
 *
 * Uses the Zustand auth store's role.role_name to derive boolean flags.
 */

import { useMemo } from 'react';
import { useAuthStore } from '@/state_management_and_stores/auth.store';
import { roleHasBuddyGroupAction } from './permissions';

export function useBuddyGroupPermissions() {
  const { role } = useAuthStore();
  const roleName = role?.role_name;

  return useMemo(() => ({
    canViewList: roleHasBuddyGroupAction(roleName, 'view_list'),
    canViewDetail: roleHasBuddyGroupAction(roleName, 'view_detail'),
    canEdit: roleHasBuddyGroupAction(roleName, 'edit_group'),
    canDissolve: roleHasBuddyGroupAction(roleName, 'dissolve_group'),
    canResolveConflicts: roleHasBuddyGroupAction(roleName, 'resolve_conflict'),
    canDismissConflicts: roleHasBuddyGroupAction(roleName, 'dismiss_conflict'),
    roleName,
  }), [roleName]);
}
